import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "md-editor-toolbar-item" };
import CustomSVG from "@/components/custom/CustomSVG.vue";
import { ref, computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PostRefSelect',
    props: {
        "posts": {},
        "postsModifiers": {},
        "handleSelect": {
            type: Function,
            required: true,
        },
        "handleSelectModifiers": {},
    },
    emits: ["update:posts", "update:handleSelect"],
    setup: function (__props) {
        var refPosts = _useModel(__props, "posts");
        var handleSelect = _useModel(__props, "handleSelect");
        var filterInputValue = ref("");
        var selectedPost = ref(null);
        var refPostsShow = computed(function () {
            var _a;
            return (_a = refPosts.value) === null || _a === void 0 ? void 0 : _a.value.filter(function (val) {
                var _a;
                return filterInputValue.value
                    ? (_a = val.label) === null || _a === void 0 ? void 0 : _a.includes(filterInputValue.value)
                    : true;
            }).map(function (item) {
                return {
                    label: item.label,
                    value: item.key,
                };
            });
        });
        var handleSelectPostID = function (postID) {
            handleSelect.value(postID);
            filterInputValue.value = "";
            selectedPost.value = null;
        };
        return function (_ctx, _cache) {
            var _component_n_input = _resolveComponent("n-input");
            var _component_n_popselect = _resolveComponent("n-popselect");
            return (_openBlock(), _createBlock(_component_n_popselect, {
                value: selectedPost.value,
                "onUpdate:value": [
                    _cache[1] || (_cache[1] = function ($event) { return ((selectedPost).value = $event); }),
                    handleSelectPostID
                ],
                options: refPostsShow.value,
                trigger: "hover",
                scrollable: "",
                style: { "width": "30vw" }
            }, {
                header: _withCtx(function () { return [
                    _createVNode(_component_n_input, {
                        value: filterInputValue.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((filterInputValue).value = $event); }),
                        placeholder: "输入文章标题模糊搜索",
                        class: "ref-filter-input",
                        style: { width: '100%' },
                        clearable: ""
                    }, null, 8, ["value"])
                ]; }),
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(CustomSVG, {
                            icon: "DataRef",
                            class: "lucide lucide-save-icon md-editor-icon"
                        })
                    ])
                ]; }),
                _: 1
            }, 8, ["value", "options"]));
        };
    }
});
